"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
require("cross-fetch/polyfill");
var lodash_1 = require("lodash");
var buffer_1 = require("buffer");
var oauth_1 = require("./controllers/oauth");
var reviews_1 = require("./controllers/reviews");
var users_1 = require("./controllers/users");
var stats_1 = require("./controllers/stats");
var jobs_1 = require("./controllers/jobs");
var feedback_1 = require("./controllers/feedback");
var applications_1 = require("./controllers/applications");
var services_1 = require("./controllers/services");
var braintree_1 = require("./controllers/braintree");
var candidates_1 = require("./controllers/candidates");
var schools_1 = require("./controllers/schools");
var Api = (function () {
    function Api() {
    }
    Api.configure = function (options) {
        var _oauth = options._oauth, other = __rest(options, ["_oauth"]);
        lodash_1.assign(Api._config, other);
        if (options.clientId && options.secret) {
            Api._apiKey = "Basic " + buffer_1.Buffer.from(options.clientId + ":" + options.secret).toString("base64");
        }
        this._debug = options.debug || this._debug;
        this._revision = options.revision || this._revision;
        if (_oauth) {
            Api.restoreUserToken(_oauth);
        }
    };
    Api.restoreUserToken = function (token) {
        var normalizedToken = token && Object.keys(token).length > 0 ? token : null;
        if (normalizedToken &&
            Api._oauth &&
            new Date(normalizedToken.dateOfExpiration).getTime() <=
                new Date(Api._oauth.dateOfExpiration).getTime()) {
            Api.log("User Token Restore: duplicated", normalizedToken);
            return Api._oauth;
        }
        Api._oauth = normalizedToken;
        if (Api.onUserTokenRefresh) {
            Api.onUserTokenRefresh(lodash_1.clone(normalizedToken));
        }
        Api.log("User Token Restore: success", normalizedToken);
        return normalizedToken;
    };
    Api.getUserToken = function () {
        return Api._oauth;
    };
    Api.getUrl = function () {
        return Api._config.url;
    };
    Api.getVersion = function () {
        return Api._version;
    };
    Api.getRevision = function () {
        return Api._revision;
    };
    Api.log = function (name, meta) {
        if (Api._debug) {
            console.info("QJ API.js: " + name, meta);
        }
    };
    Api._config = {
        url: "",
        clientId: "",
        secret: "",
    };
    Api._version = "v2";
    Api._revision = "2.1.0";
    Api._debug = false;
    Api._apiKey = "";
    Api._oauth = null;
    Api.onUserTokenRefresh = function () { };
    Api.onRefreshTokenExpiration = function () { };
    Api.authorization = oauth_1.default;
    Api.users = users_1.default;
    Api.stats = stats_1.default;
    Api.jobs = jobs_1.default;
    Api.applications = applications_1.default;
    Api.feedback = feedback_1.default;
    Api.reviews = reviews_1.default;
    Api.services = services_1.default;
    Api.braintree = braintree_1.default;
    Api.candidates = candidates_1.default;
    Api.schools = schools_1.default;
    return Api;
}());
exports.default = Api;
__export(require("./types"));
//# sourceMappingURL=index.js.map